// extracted by mini-css-extract-plugin
export default {"serverReadinessScreen":"serverReadinessScreen-hqr4i","content":"content-SmOtu","loadingMessage":"loadingMessage-sOZUE","subtext":"subtext-ytepu"};